import React,{useState,useEffect} from 'react'
import {Modal} from 'react-bootstrap'
function ErrorPopup(props){
    const [show,setShow] = useState(true)
    const onHide = () =>{
        setShow(false)
        props.hide()
    }
    useEffect(()=>{
        setShow(props.show)
    },[props.show])
    return(
        <div>
            <Modal show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    An error has occurred
                </Modal.Header>
                <Modal.Body>
                    {props.text}.
                    
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default ErrorPopup

ErrorPopup.defaultProps = {
    show:false,
}